import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-down",
  "use": "icon-down-usage",
  "viewBox": "0 0 16.07 9.45",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16.07 9.45\" id=\"icon-down\"><defs><style>#icon-down .cls-1{fill:none;stroke:#999;stroke-linecap:round;stroke-miterlimit:10;stroke-width:2px;}</style></defs><title>资源 11</title><g id=\"icon-down_图层_2\" data-name=\"图层 2\"><g id=\"icon-down_图层_1-2\" data-name=\"图层 1\"><polyline class=\"cls-1\" points=\"15.07 1 8.04 8.04 1 1\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol